import {
  Component,
  OnInit,
  Input,
  OnChanges,
  AfterViewChecked,
  ViewChild,
  Injectable,
} from '@angular/core';
import { KanziRestClientService } from '@kanzi-apes/kanzi-rest-api';
import { EnvironmentService } from '@kanzi-apes/kanzi-utils';
import { Observable } from 'rxjs/';
import moment from 'moment';
import {
  CustomerModel,
  StockSaleSummaryListModel,
  KanziActions,
  StockSaleSummaryFilterModel,
  DataListModel,
  TracesFilterModel,
} from '@kanzi-apes/kanzi-models';

interface LocationSalesTotalsModel {
  location_id: number;
  location_name: string;
  total1: number;
  total2?: number;
}

@Component({
    selector: 'lib-kanzi-sales-comparative-chart',
    templateUrl: './kanzi-sales-comparative-chart.component.html',
    styleUrls: ['./kanzi-sales-comparative-chart.component.scss'],
    standalone: false
})
export class KanziSalesComparativeChartComponent
  implements OnInit, OnChanges, AfterViewChecked
{
  // @ViewChild(DxChartComponent, { static: false }) chart!: DxChartComponent;
  // @ViewChild(DxFunnelComponent, { static: false }) chartFunnel!: DxFunnelComponent;
  @Input() title: string = '';
  @Input() headerText: string = '';
  @Input() customer: CustomerModel | null = null;
  private kongUrl = this.envService.environment!.kongApi;
  private salesTotalsUrl = `${this.kongUrl}${
    this.envService.environment!.apiModules.inventory
  }moves/type-totals-by-location/`;
  private tracesPath = `${this.kongUrl}${
    this.envService.environment!.apiModules.inventory
  }traces/`;
  today!: Date;
  startMonth: string = '';
  endMonth: string = '';
  filtersStockSale!: StockSaleSummaryFilterModel;
  filtersStockSaleShow!: StockSaleSummaryFilterModel;
  locationSalesTotalsData: LocationSalesTotalsModel[] = [];
  rangeDates: Date[] = [];

  constructor(
    private apiClientService: KanziRestClientService,
    private envService: EnvironmentService
  ) {}

  ngOnInit(): void {}
  ngOnChanges() {
    this.filtersStockSale = {
      page: 1,
      page_size: 1000,
      type: `${KanziActions.SALE_OUT},${KanziActions.RETURN}`,
      sub_location__type_id: 16,
      customer_id: this.customer ? this.customer.id : null,
    };
    this.filtersStockSaleShow = {
      ...this.filtersStockSale,
      reporter_source: 'POS_DEVICE',
    };

    this.generateFunnelData();
  }
  ngAfterViewChecked() {
    // this.chart.instance.render();
    // this.chartFunnel.instance.render();
  }

  clearData() {
    this.rangeDates = [];
    this.locationSalesTotalsData = [];
  }

  generateFunnelData() {
    // Get First Showroom Totals
    this.apiClientService
      .get<StockSaleSummaryListModel>(
        this.salesTotalsUrl,
        this.filtersStockSaleShow,
        'Error al traer el resumen de las ventas.'
      )
      .subscribe((stockSaleSummaryListShow) => {
        if (stockSaleSummaryListShow.count > 0) {
          this.locationSalesTotalsData.push({
            location_id: stockSaleSummaryListShow.results[0].sub_location.id!,
            location_name: `${stockSaleSummaryListShow.results[0].sub_location.display_name}<br>Showroom`,
            total1: stockSaleSummaryListShow.results[0].total_amount,
          });
        }
        this.apiClientService
          .get<StockSaleSummaryListModel>(
            this.salesTotalsUrl,
            this.filtersStockSale,
            'Error al traer el resumen de las ventas.'
          )
          .subscribe((stockSaleSummaryList) => {
            if (stockSaleSummaryList.count > 0) {
              this.locationSalesTotalsData.push({
                location_id: stockSaleSummaryList.results[0].sub_location.id!,
                location_name: `${stockSaleSummaryList.results[0].sub_location.display_name}<br>Bodega`,
                total1: this.differenceTwoValues(
                  stockSaleSummaryList.results[0].total_amount,
                  stockSaleSummaryListShow.count > 0
                    ? stockSaleSummaryListShow.results[0].total_amount
                    : 0
                ),
              });
            }
          });
      });
  }

  customizeText(arg: any) {
    return (
      '<span style="font-size: 28px">' +
      arg.percentText +
      '</span><br/>' +
      arg.item.argument
    );
  }

  customizeTooltip(args: any) {
    return {
      html: `${args.argumentText} | ${args.seriesName}<br><strong>Total Ventas:</strong> ${args.valueText}`,
    };
  }

  onSeriesClick(e: any) {
    const series = e.target;
    if (series.isVisible()) {
      series.hide();
    } else {
      series.show();
    }
  }

  differenceTwoValues(value1: number, value2: number): number {
    const result = value1 - value2;
    return result < 0 ? result * -1 : result;
  }

  selectDateRange(range: Date[]) {
    if (range[1]) {
      const initDate = moment(range[0]).format('MM/DD/YYYY');
      const endDate = moment(range[1]).format('MM/DD/YYYY');
      this.filtersStockSale = {
        page: 1,
        page_size: 1000,
        type: `${KanziActions.SALE_OUT},${KanziActions.RETURN}`,
        sub_location__type_id: 16,
        customer_id: this.customer ? this.customer.id : null,
        created_min: initDate,
        created_max: endDate,
      };
      this.filtersStockSaleShow = {
        ...this.filtersStockSale,
        reporter_source: 'POS_DEVICE',
      };
      this.locationSalesTotalsData = [];
      this.generateFunnelData();
    }
  }

  clearFilters() {
    this.filtersStockSale = {
      page: 1,
      page_size: 1000,
      type: `${KanziActions.SALE_OUT},${KanziActions.RETURN}`,
      sub_location__type_id: 16,
      customer_id: this.customer ? this.customer.id : null,
    };
    this.filtersStockSaleShow = {
      ...this.filtersStockSale,
      reporter_source: 'POS_DEVICE',
    };
    this.locationSalesTotalsData = [];
    this.generateFunnelData();
  }
}
